import React from 'react';

export default function HolidayCard2023() {
  return (
    <iframe src="https://www.liamkreiss.me/html/2023-holiday-card.html" width="100%" height="100%" title='2023 holiday card'></iframe>
  );
}
